<div class="utils-table">
  @if (isTableInitiating) {
    <app-utils-action-buttons-skeleton></app-utils-action-buttons-skeleton>
    <app-utils-table-skeleton></app-utils-table-skeleton>
  } @else {
    @if (type === 'Archive') {
      <app-archive-filters [tab]="tab"></app-archive-filters>
    } @else {
      <app-utils-action-buttons
        [tab]="tab"
        [tabIndex]="tabIndex"
        [selectedItems]="selectedItems"
        [searchValue]="searchValueFromUrl"
        (cleared)="onClearFilters()"></app-utils-action-buttons>
    }
    <mat-drawer-container>
      <mat-drawer class="utils-table__drawer" #drawer mode="side" position="end">
        @switch (tab?.type) {
          @case ('Shipments') {
            <app-shipment-details
              [shipmentNo]="shipmentNo()"
              [openedFrom]="'Shipments'"
              [isArchived]="type === 'Archive'"
              (detailsClosed)="closeDrawer()"></app-shipment-details>
          }
          @case ('Containers') {
            <app-container-details
              [containerId]="containerId()"
              [isArchived]="type === 'Archive'"
              (detailsClosed)="closeDrawer()">
            </app-container-details>
          }
          @case ('Orders') {
            <app-order-details [orderId]="orderId()" [isArchived]="type === 'Archive'" (detailsClosed)="closeDrawer()">
            </app-order-details>
          }
          @case ('OrderExceptions') {
            <app-order-exception-details
              [orderExceptionId]="orderExceptionId()"
              [isArchived]="type === 'Archive'"
              (detailsClosed)="closeDrawer()">
            </app-order-exception-details>
          }
        }
      </mat-drawer>
      <mat-drawer-content [ngClass]="{ 'utils-table__drawer-content--opened': drawer.opened }">
        <div class="utils-table__table-wrapper">
          <table
            mat-table
            [dataSource]="tableData.data"
            class="utils-table__table"
            matSort
            (matSortChange)="onSort($event)">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </td>
            </ng-container>
            @for (column of tableColumns; track index; let index = $index) {
              <ng-container [matColumnDef]="column.columnKey">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="utils-table__table--header">
                    <div>
                      @if (column.facetable && type !== 'Archive') {
                        @if (column.dataType === 'DateTime') {
                          <app-date-range-facet-filter
                            #dateRangeFacetFilter
                            [columnKey]="column.columnKey"
                            (selectedDates)="onDateRangeFacetSelect($event)">
                          </app-date-range-facet-filter>
                        } @else {
                          <app-facet-filter
                            #facetFilter
                            [filterValues]="tableData.facets | facetsByColumnKey: column.columnKey"
                            [columnKey]="column.columnKey"
                            (selectedValues)="onFacetsSelect($event)"></app-facet-filter>
                        }
                      }
                    </div>
                    <span mat-sort-header [disabled]="!column.sortable || type === 'Archive'">{{ column.name }}</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  <div [appEllipsisTooltip]="element | nestedProperty: column.accessPath | stripHtml">
                    <app-table-value-formatter
                      [value]="element | nestedProperty: column.accessPath"
                      [column]="column"></app-table-value-formatter>
                  </div>
                </td>
              </ng-container>
            }
            <tr
              mat-header-row
              *matHeaderRowDef="columnsToDisplay; sticky: true"
              class="utils-table__table--header-row"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: columnsToDisplay"
              (click)="onRowClick(row)"
              class="utils-table__table--row"
              [ngClass]="{ 'utils-table__table--row--selected': isEntityAlreadyOpened(row) }"></tr>
            <ng-container matColumnDef="isDataAvailable">
              <td mat-footer-cell [colSpan]="columnsToDisplay.length" *matFooterCellDef>No data found</td>
            </ng-container>
            <tr
              mat-footer-row
              *matFooterRowDef="['isDataAvailable']"
              [ngClass]="{ 'no-results': tableData.data.length > 0 || isLoading }"></tr>
          </table>
        </div>
        <mat-paginator
          [disabled]="isLoading"
          [pageIndex]="(tableData.pageNumber || 1) - 1"
          [length]="tableData.totalCount"
          [pageSize]="tableData.pageSize"
          [pageSizeOptions]="[20, 50, 200]"
          (page)="onPaginationChange($event)"></mat-paginator>
      </mat-drawer-content>
    </mat-drawer-container>
    @if (isLoading) {
      <div class="spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    }
  }
</div>
